import axios from "axios";

export default function GuestEntryreasonService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/guest_entry_reason",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
